import React, { useMemo } from 'react';
import Chart from 'react-apexcharts';

const HACCPChart6 = ({ jmlHaccp }) => {
  const chartDonutHaccp = useMemo(() => {
    if (!jmlHaccp || !jmlHaccp.A || !jmlHaccp.B || !jmlHaccp.C) return null;

    return {
      options: {
        chart: {
          type: "donut",
          height: 250,
          width: 250,
          toolbar: { show: false }
        },
        labels: ["Grade A", "Grade B", "Grade C"],
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            const count = [jmlHaccp.A, jmlHaccp.B, jmlHaccp.C][opts.seriesIndex];
            return `${val.toFixed(2)}%`;
          },
          style: {
            fontSize: "12px",
            fontWeight: "bold"
          }
        },
        plotOptions: {
          pie: {
            donut: {
              size: '45%',
              labels: {
                show: true,
                name: { show: false },
                value: { show: false },
                total: {
                  show: true,
                  showAlways: true,
                  label: 'JUMLAH',
                  fontSize: '16px',
                  fontWeight: 600,
                  formatter: function () {
                    return `${jmlHaccp.JUMLAH}`;
                  }
                }
              }
            }
          }
        },
        legend: {
          show: true,
          position: 'bottom',
        },
        colors: ['#008FFB', '#FF4560', '#00E396'],
      },
      series: [jmlHaccp.A, jmlHaccp.B, jmlHaccp.C]
    };
  }, [jmlHaccp]);

  if (!chartDonutHaccp) return null;

  return (
    <Chart
      options={chartDonutHaccp.options}
      series={chartDonutHaccp.series}
      type="donut"
      height={300}
    />
  );
};

export default HACCPChart6;
